export const ThemeColors = {
	light: '#ffffff',
	dark: '#0a0e14',
} as const;
